import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "home" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, "Shayne", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "menu-icon navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarOnMobile",
  "aria-controls": "navbarNavAltMarkup",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarOnMobile"
}
const _hoisted_6 = { class: "navbar-nav ms-auto" }
const _hoisted_7 = {
  class: "nav-link",
  style: {"--bs-nav-link-font-size":"10px"}
}
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeView = _resolveComponent("HomeView")!
  const _component_Waypoint = _resolveComponent("Waypoint")!
  const _component_AboutView = _resolveComponent("AboutView")!
  const _component_EnEView = _resolveComponent("EnEView")!
  const _component_SkillView = _resolveComponent("SkillView")!
  const _component_WorkView = _resolveComponent("WorkView")!
  const _component_SpecialView = _resolveComponent("SpecialView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["nav-wrap", [_ctx.isTop? 'nav-bg-tran': 'nav-bg-light' ]]),
        id: "nav"
      }, [
        _createElementVNode("nav", {
          class: _normalizeClass(["navbar navbar-expand-lg", [_ctx.isTop? 'navbar-dark': 'navbar-light']])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLists, (navItem) => {
                  return (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["d-none d-lg-block", [_ctx.isTop? 'text-light' : 'text-dark']]),
                      href: navItem.path
                    }, _toDisplayString(navItem.name), 11, _hoisted_8),
                    _createElementVNode("a", {
                      class: "d-lg-none text-light",
                      href: navItem.path
                    }, _toDisplayString(navItem.name), 9, _hoisted_9)
                  ]))
                }), 256)),
                _createElementVNode("li", {
                  class: "nav-link lang-text",
                  style: {"--bs-nav-link-font-size":"10px"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setLang && _ctx.setLang(...args)))
                }, _toDisplayString(_ctx.$t('btn-lang')), 1)
              ])
            ])
          ])
        ], 2)
      ], 2)
    ]),
    _createVNode(_component_Waypoint, { onChange: _ctx.onchange }, {
      default: _withCtx(() => [
        _createVNode(_component_HomeView)
      ]),
      _: 1
    }, 8, ["onChange"]),
    _createVNode(_component_AboutView),
    _createVNode(_component_EnEView),
    _createVNode(_component_SkillView),
    _createVNode(_component_WorkView),
    _createVNode(_component_SpecialView)
  ], 64))
}